import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContentBlockState } from '../reducers/content-block.reducer';
import { CONTENT_BLOCK_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<ContentBlockState>(CONTENT_BLOCK_FEATURE_KEY);

export const selectContentBlock = (id: string) => createSelector(selectState, (state) => state[id]?.data);
export const selectContentBlockLoading = (id: string) => createSelector(selectState, (state) => state[id]?.loading ?? false);
export const selectContentBlockLoaded = (id: string) => createSelector(selectState, (state) => state[id]?.loaded ?? false);
